import React from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'components/Table';
import TraroElement from 'types/api/TraroElement';
import { useSelector } from 'store';
import { useRfpBidHistory } from 'api';
import BidEntryDto from 'types/api/BidEntryDto';
import Markdown from 'components/Markdown/Markdown';

import useColumns from './hooks/useColumns';

import './BidHistory.scss';

export interface BidHistoryProps {
  element: TraroElement;
}

const emptyArray: BidEntryDto[] = [];

const BidHistory = ({ element }: BidHistoryProps) => {
  const { t } = useTranslation();
  const rfpId = useSelector((state) => state.rfp.data.id);

  const columns = useColumns();
  const { data, error } = useRfpBidHistory(rfpId, element.id!);

  return (
    <div className="enkrateia-bid-history">
      <h2>{t('pages.prosforaElement.bidHistory.title')}</h2>
      <Table
        columns={columns}
        data={error ? emptyArray : data}
        emptyDataSetMessage={
          error ? (
            <div className="warning">
              <Markdown>{error.message}</Markdown>
            </div>
          ) : (
            t('pages.prosforaElement.bidHistory.noBids')
          )
        }
      />
    </div>
  );
};

export default BidHistory;
